import React, { useContext, useEffect, useState } from 'react';
import ajaxCallStation from '../util/remote/ajaxCallStation';
import SchoolContext from './SchoolContext';

const CallContext = React.createContext();

export const CallConsumer = CallContext.Consumer;

export const CallProvider = (props)=> {

    const [twilioLogsList, setTwilioLogsList] = useState([]);
    const [zegoLogsList, setZegoLogsList] = useState([]);
    const [buzzVideoLogsList, setBuzzVideoLogsList] = useState([]);

    const [schoolTwilioLogsList, setSchoolTwilioLogsList] = useState([]);
    const [schoolZegoLogsList, setSchoolZegoLogsList] = useState([]);

    const [twilioStartDate, setTwilioStartDate] = useState("");
    const [zegoStartDate, setZegoStartDate] = useState("");
    const [buzzVideoStartDate, setBuzzVideoStartDate] = useState("");

    const [twilioEndDate, setTwilioEndDate] = useState("");
    const [zegoEndDate, setZegoEndDate] = useState("");
    const [buzzVideoEndDate, setBuzzVideoEndDate] = useState("");

    const [loading, setLoading] = useState(false);
    const [loading2, setLoading2] = useState(false);

    const [twilioPage,setTwilioPage] = useState(1)
    const [zegoPage,setZegoPage] = useState(1)
    const [buzzVideoPage,setBuzzVideoPage] = useState(1)

    const [twilioMeta,setTwilioMeta] = useState([])
    const [zegoMeta,setZegoMeta] = useState([])
    const [buzzVideoMeta,setBuzzVideoMeta] = useState([])

    const [twilioCaller, setTwilioCaller] = useState("");
    const [zegoCaller, setZegoCaller] = useState("");
    const [buzzVideoCaller, setBuzzVideoCaller] = useState("");

    const [twilioSchool, setTwilioSchool] = useState("");
    const [zegoSchool, setZegoSchool] = useState("");
    const [buzzVideoSchool, setBuzzVideoSchool] = useState("");

    const [isTwilioSearching, setIsTwilioSearching] = useState(false);
    const [isZegoSearching, setIsZegoSearching] = useState(false);
    const [isBuzzVideoSearching, setIsBuzzVideoSearching] = useState(false);

    const [isFirstLoad, setIsFirstLoad] = useState(true);
    const [isRealTimeEnabled, setIsRealTimeEnabled] = useState(true);
    
    const { schoolDetails } = useContext(SchoolContext);

    const schoolID = schoolDetails.school_id;
    const [callHighlights, setCallHighlights] = useState([]);
    const [messageHighlights, setMessageHighlights] = useState([]);

    const [globalCommunicationSettings, setGlobalCommunicationSettings] = useState(false);
    const [schoolCommunicationSettings, setSchoolCommunicationSettings] = useState(false);
    const [stationCommunicationSettings, setStationCommunicationSettings] = useState(false);
    const [twilioBalance, setTwilioBalance] = useState(false);

    useEffect(() => {
        getCallHighlights();
        getMessageHighlights();
    }, []);

    const getTwilioLogsList = async (currentPage) => {
        if (isFirstLoad) setLoading(true);
      
        try {
          const server_response = await ajaxCallStation.listTwilioCallLogs(currentPage);
          if (server_response.status === "OK") {
            setTwilioMeta(server_response.details.meta.totalPages);
            setTwilioLogsList(server_response.details.data || []);
          } else {
            setTwilioLogsList([]);
          }
        } catch (error) {
          console.error("Error fetching Twilio logs:", error);
        } finally {
          setLoading(false);
          if (isFirstLoad) setIsFirstLoad(false); // Disable loader after the first load
        }
    };

    const getSchoolTwilioLogsList = async (currentPage) => {
      if (isFirstLoad) setLoading(true);
    
      try {
        const server_response = await ajaxCallStation.listSchoolTwilioCallLogs(currentPage, schoolID);
        if (server_response.status === "OK") {
          setTwilioMeta(server_response.details.meta.totalPages);
          setSchoolTwilioLogsList(server_response.details.data || []);
        } else {
          setSchoolTwilioLogsList([]);
        }
      } catch (error) {
        console.error("Error fetching Twilio logs:", error);
      } finally {
        setLoading(false);
        if (isFirstLoad) setIsFirstLoad(false); // Disable loader after the first load
      }
  };

    const getZegoLogsList = async (currentPage) => {
        if (isFirstLoad) setLoading(true);
      
        try {
          const server_response = await ajaxCallStation.listZegoCallLogs(currentPage);
          if (server_response.status === "OK") {
            setZegoMeta(server_response.details.meta.totalPages);
            setZegoLogsList(server_response.details.data || []);
          } else {
            setZegoLogsList([]);
          }
        } catch (error) {
          console.error("Error fetching Zego logs:", error);
        } finally {
          setLoading(false);
          if (isFirstLoad) setIsFirstLoad(false); 
        }
    };

    const getBuzzVideoLogsList = async (currentPage) => {
      if (isFirstLoad) setLoading(true);
    
      try {
        const server_response = await ajaxCallStation.listBuzzVideoCallLogs(currentPage);
        if (server_response.status === "OK") {
          setBuzzVideoMeta(server_response.details.meta.totalPages);
          setBuzzVideoLogsList(server_response.details.data || []);
        } else {
          setBuzzVideoLogsList([]);
        }
      } catch (error) {
        console.error("Error fetching Buzz video logs:", error);
      } finally {
        setLoading(false);
        if (isFirstLoad) setIsFirstLoad(false); 
      }
  };

    const getSchoolZegoLogsList = async (currentPage) => {
      if (isFirstLoad) setLoading(true);
    
      try {
        const server_response = await ajaxCallStation.listSchoolZegoCallLogs(currentPage, schoolID);
        if (server_response.status === "OK") {
          setZegoMeta(server_response.details.meta.totalPages);
          setSchoolZegoLogsList(server_response.details.data || []);
        } else {
          setSchoolZegoLogsList([]);
        }
      } catch (error) {
        console.error("Error fetching Zego logs:", error);
      } finally {
        setLoading(false);
        if (isFirstLoad) setIsFirstLoad(false); 
      }
  };

    const searchTwilioLogs = async (e) => {
        if (e) {
          e.preventDefault();
        }
        setLoading2(true);
        setIsTwilioSearching(true);
        const server_response = await ajaxCallStation.searchTwilioLogs(twilioPage, twilioCaller, twilioSchool, twilioStartDate, twilioEndDate);
        setLoading2(false);
        if (server_response.status === "OK") {
          setTwilioMeta(server_response.details.meta.totalPages);
          setTwilioLogsList(server_response.details.data || []);
        } else {
          setTwilioLogsList([]);
        }     
    };

    const searchSchoolTwilioLogs = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      setIsTwilioSearching(true);
      const server_response = await ajaxCallStation.searchSchoolTwilioLogs(twilioPage, twilioCaller, twilioStartDate, twilioEndDate, schoolID);
      setLoading2(false);
      if (server_response.status === "OK") {
        setTwilioMeta(server_response.details.meta.totalPages);
        setSchoolTwilioLogsList(server_response.details.data || []);
      } else {
        setSchoolTwilioLogsList([]);
      }     
  };

    const searchZegoLogs = async (e) => {
        if (e) {
          e.preventDefault();
        }
        setLoading2(true);
        setIsZegoSearching(true);
        const server_response = await ajaxCallStation.searchZegoLogs(zegoPage, zegoCaller, zegoSchool, zegoStartDate, zegoEndDate);
        setLoading2(false);
        if (server_response.status === "OK") {
          setZegoMeta(server_response.details.meta.totalPages);
          setZegoLogsList(server_response.details.data || []);
        } else {
          setZegoLogsList([]);
        }     
    };

    const searchBuzzVideoLogs = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      setIsBuzzVideoSearching(true);
      const server_response = await ajaxCallStation.searchBuzzVideoLogs(buzzVideoPage, buzzVideoCaller, buzzVideoSchool, buzzVideoStartDate, buzzVideoEndDate);
      setLoading2(false);
      if (server_response.status === "OK") {
        setBuzzVideoMeta(server_response.details.meta.totalPages);
        setBuzzVideoLogsList(server_response.details.data || []);
      } else {
        setBuzzVideoLogsList([]);
      }     
  };

    const searchSchoolZegoLogs = async (e) => {
      if (e) {
        e.preventDefault();
      }
      setLoading2(true);
      setIsZegoSearching(true);
      const server_response = await ajaxCallStation.searchSchoolZegoLogs(zegoPage, zegoCaller, zegoStartDate, zegoEndDate, schoolID);
      setLoading2(false);
      if (server_response.status === "OK") {
        setZegoMeta(server_response.details.meta.totalPages);
        setSchoolZegoLogsList(server_response.details.data || []);
      } else {
        setSchoolZegoLogsList([]);
      }     
  };

  const getCallHighlights = async () => {
      const server_response = await ajaxCallStation.callHighlights();
      if (server_response.status === "OK") {
        //store results
        setCallHighlights(server_response.details);
      } else {
        //communicate error
        setCallHighlights([]);
      }
  };

  const getMessageHighlights = async () => {
      const server_response = await ajaxCallStation.messageHighlights();
      if (server_response.status === "OK") {
        //store results
        setMessageHighlights(server_response.details);
      } else {
        //communicate error
        setMessageHighlights([]);
      }
  };

  const getGlobalCommunicationSettings =async()=>{
  
        const server_response = await ajaxCallStation.fetchGlobalCommunicationSettings();
        
        if(server_response.status==="OK"){
           //store results
           setGlobalCommunicationSettings(server_response.details);
        }else{
           //communicate error
           setGlobalCommunicationSettings("404");
        }
     }
  
     const getSchoolCommunicationSettings =async()=>{
  
        const server_response = await ajaxCallStation.fetchSchoolCommunicationSettings();

        if(server_response.status==="OK"){
           //store results
           setSchoolCommunicationSettings(server_response.details);
        }else{
           //communicate error
           setSchoolCommunicationSettings("404");
        }
     }

     const getStationCommunicationSettings =async()=>{
  
        const server_response = await ajaxCallStation.fetchStationCommunicationSettings();

        if(server_response.status==="OK"){
           //store results
           setStationCommunicationSettings(server_response.details);
        }else{
           //communicate error
           setStationCommunicationSettings("404");
        }
     }

     const getTwilioBalance = async () => {
        const server_response = await ajaxCallStation.getTwilioBalance();
        if (server_response.status === "OK") {
          setTwilioBalance(server_response.details);
        } else {
          setTwilioBalance(false);
        }
      };

    
  return (
    <CallContext.Provider value={
      {
        twilioLogsList,
        zegoLogsList,
        buzzVideoLogsList,
        schoolTwilioLogsList,
        schoolZegoLogsList,
        twilioSchool,
        zegoSchool,
        buzzVideoSchool,
        twilioCaller,
        zegoCaller,
        buzzVideoCaller,
        twilioEndDate,
        zegoEndDate,
        buzzVideoEndDate,
        twilioStartDate,
        zegoStartDate,
        buzzVideoStartDate,
        twilioMeta,
        zegoMeta,
        buzzVideoMeta,
        buzzVideoPage,
        twilioPage,
        zegoPage,
        isTwilioSearching,
        isZegoSearching,
        isBuzzVideoSearching,
        isFirstLoad,
        isRealTimeEnabled,
        loading,
        loading2,
        schoolID,
        callHighlights,
        globalCommunicationSettings,
        schoolCommunicationSettings,
        stationCommunicationSettings,
        messageHighlights,
        twilioBalance,
        searchTwilioLogs,
        searchZegoLogs,
        searchBuzzVideoLogs,
        searchSchoolTwilioLogs,
        searchSchoolZegoLogs,
        getTwilioLogsList,
        getZegoLogsList,
        getBuzzVideoLogsList,
        getSchoolTwilioLogsList,
        getSchoolZegoLogsList,
        setTwilioPage,
        setZegoPage,
        setBuzzVideoPage,
        setIsRealTimeEnabled,
        setTwilioSchool,
        setZegoSchool,
        setBuzzVideoSchool,
        setTwilioCaller,
        setZegoCaller,
        setBuzzVideoCaller,
        setTwilioEndDate,
        setZegoEndDate,
        setBuzzVideoEndDate,
        setTwilioStartDate,
        setZegoStartDate,
        setBuzzVideoStartDate,
        setIsTwilioSearching,
        setIsZegoSearching,
        setIsBuzzVideoSearching,
        getCallHighlights,
        getGlobalCommunicationSettings,
        getSchoolCommunicationSettings,
        getStationCommunicationSettings,
        getMessageHighlights,
        getTwilioBalance

      }
    }>
    {props.children}
    </CallContext.Provider>
  );
    
}

export default CallContext;